import { drilldownData, ModuleFields } from "@utils/drilldownData";

export type FormType = "userProfileSettings" | "purchaseSuccess" | "purchaseQR";

export const fields: any = {
  userProfileSettings: drilldownData["userProfileSettings"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  purchaseSuccess: drilldownData["purchaseSuccess"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  purchaseQR: drilldownData["purchaseQR"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
};
